import SettingUp from '@views/Auth/views/Register/SettingUp';
import SettingsAccount from '@views/Settings/Account';
import CompanyCreationView from '@views/SetUp/Company/CompanyCreationView.vue';
import PlaceCreationView from '@views/SetUp/Location/PlaceCreationView';
// TODO: hot fix cause separate module might cause an error

export default [
    {
        path: '/account-settings',
        components: { base: SettingsAccount },
        name: 'settings.account',
    },
    {
        path: '/create/company',
        name: 'create.company',
        components: { base: CompanyCreationView },
        meta: {
            hideNav: false,
            isCreateNew: true,
        },
    },
    {
        path: '/create/place',
        name: 'create.place',
        components: { base: PlaceCreationView },
    },
    {
        path: '/setting-up',
        name: 'create.setting-up',
        components: { base: SettingUp },
        meta: {
            hideNav: true,
        },
    },
];
